import { Record } from 'immutable';
import { INBOX_CHANGE_REMOVAL } from '../constants/overlayTypes';
const InboxChangeRemovalOverlay = Record({
  audit: null,
  type: INBOX_CHANGE_REMOVAL,
  inboxId: null
}, 'InboxChangeRemovalOverlay');
export default InboxChangeRemovalOverlay;